module.exports = __webpack_public_path__ + "static/media/audiodark.d31cccbe.svg";